module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-galleria-thumbnail-wrapper"
  }, [_c('div', {
    staticClass: "p-galleria-thumbnail-container"
  }, [(_vm.showThumbnailNavigators) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.navBackwardClass,
    attrs: {
      "disabled": _vm.isNavBackwardDisabled(),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.navBackward($event)
      }
    }
  }, [_c('span', {
    class: _vm.navBackwardIconClass
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-galleria-thumbnail-items-container",
    style: ({
      'height': _vm.isVertical ? _vm.contentHeight : ''
    })
  }, [_c('div', {
    ref: "itemsContainer",
    staticClass: "p-galleria-thumbnail-items",
    on: {
      "transitionend": _vm.onTransitionEnd,
      "touchstart": function($event) {
        return _vm.onTouchStart($event)
      },
      "touchmove": function($event) {
        return _vm.onTouchMove($event)
      },
      "touchend": function($event) {
        return _vm.onTouchEnd($event)
      }
    }
  }, _vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: ("p-galleria-thumbnail-item-" + index),
      class: ['p-galleria-thumbnail-item', {
        'p-galleria-thumbnail-item-current': _vm.activeIndex === index,
        'p-galleria-thumbnail-item-active': _vm.isItemActive(index),
        'p-galleria-thumbnail-item-start': _vm.firstItemAciveIndex() === index,
        'p-galleria-thumbnail-item-end': _vm.lastItemActiveIndex() === index
      }]
    }, [_c('div', {
      staticClass: "p-galleria-thumbnail-item-content",
      attrs: {
        "tabindex": _vm.isItemActive(index) ? 0 : null
      },
      on: {
        "click": function($event) {
          return _vm.onItemClick(index)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onItemClick(index)
        }
      }
    }, [_c('GalleriaItemSlot', {
      attrs: {
        "type": "thumbnail",
        "item": item,
        "templates": _vm.templates
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (_vm.showThumbnailNavigators) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.navForwardClass,
    attrs: {
      "disabled": _vm.isNavForwardDisabled(),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.navForward($event)
      }
    }
  }, [_c('span', {
    class: _vm.navForwardIconClass
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfaf9d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/galleria/GalleriaThumbnails.vue
// module id = 2256
// module chunks = 0